<template>
  <a-modal
      title="绑定IC卡"
      :visible="showModal"
      @ok="clickOk"
      @cancel="showModal=false"
      class="customermodel"
      width="500px"
      :centered="true"
    >
      <div class="replacedcard-model">
        <a-form :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
          <a-form-item label="IC卡">
            <a-input ref="cardInput" size="large" v-model="newCard" @keyup.enter="transIC" @keyup="onKeyup" />
          </a-form-item>
        </a-form>
        <a-row>
          <a-col :offset="4">
            <div class="tips fprimary">
              <b>注：</b>请使用读卡器，读取饭卡ID进行绑定
            </div>
          </a-col>
        </a-row>
      </div>
    </a-modal>
</template>
<script>
import { mapState } from 'vuex'
import apis from '@/business/apis'
export default {
  inject: ['eventBus'],
  data () {
    return {
      data: {},
      newCard: '',
      showModal: false,
      tmpTime: 0
    }
  },
  computed: {
    ...mapState('school', [
      'currentSchool'
    ])
  },
  methods: {
    async showThisModal (data) {
      this.newCard = ''
      this.showModal = true
      this.data = data
      this.$nextTick(() => {
        this.$refs.cardInput.focus()
      })
    },
    async clickOk () {
      this.newCard = this.newCard.trim()
      if (!this.newCard) {
        this.$message.info('IC卡不能为空')
        return
      }
      if (this.newCard.length !== 8) {
        this.$message.info('IC卡格式错误')
        return
      }
      if (this.newCard === this.data.ic_card) {
        this.$message.info('IC卡与原来一样')
        return
      }
      const data = {
        schoolId: this.currentSchool._id,
        cardNum: this.data.card_num,
        ic: this.newCard,
        type: 'bind',
        customerId: this.data.customer_id
      }
      const response = await this.$http.post(apis.user.changeIcCard, data)
      if (response.body.err) {
        return
      }
      this.data.ic_card = this.newCard
      this.showModal = false
    },
    transIC () {
      if (this.newCard.length > 7 && new Date().getTime() - this.tmpTime < 500) {
        const icNum = Number(this.newCard)
        if (!icNum) return
        const parts = []
        for (let i = 24; i >= 0; i = i - 8) {
          parts.push(
            `0${((icNum >> i) & 0xff).toString(16).toUpperCase()}`.slice(-2)
          )
        }
        this.newCard = parts.reverse().join('')
        this.$refs.cardInput.blur()
      }
    },
    onKeyup () {
      if (this.newCard.length === 1) {
        this.tmpTime = new Date().getTime()
      }
    }
  },
  created () {
    this.eventBus.$on('show-change-iccard-modal', this.showThisModal)
  },
  beforeDestroy () {
    this.eventBus.$off('show-change-iccard-modal', this.showThisModal)
  }
}
</script>
